import request from '../utils/request';

export function getBalanceRulesList(param) {
    return request({
        url: '/admin/search-balance-rules',
        method: 'GET',
        params: param
    })
}

export function saveBalanceRules(id, data) {
    if (id === 0) {
        return request({
            url: '/admin/balance-rule',
            method: 'POST',
            data
        })
    }

    return request({
        url: '/admin/balance-rule/'+id,
        method: 'PUT',
        data
    })
}

export function setBalanceRuleIsvalidate(id, isvalidate) {
    return request({
        url: '/admin/balance-rule/'+id+'/is-validate/'+isvalidate,
        method: 'PUT'
    })
}


export function getBalanceRule(id) {
    return request({
        url: '/admin/balance-rule/' + id,
        method: 'GET'
    })
}

export function deleteBalanceRule(id) {
    return request({
        url: '/admin/balance-rule/' + id,
        method: 'DELETE'
    })
}

export function getRecordList(param) {
    return request({
        url: '/admin/search-recharge',
        method: 'GET',
        params:param
    })
}
